import { useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import { defaultPageRowOptions, defaultRowOptions, inOut, inOutTypes, SkeletonbodyTemplate, Skeletonitems } from '../../../appconfig/Settings';
import { getAllDetailsDirect, postAllData } from '../../../service/ProductService';
import { DOWNLOADCOLLEGEWISEREGISTRATION, DOWNLOADINOUTREGISTER, INWARDOUTWARDREPORT, SUBTYPE } from '../../../config/ApiConstant';

import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import moment from 'moment';
import { downloadData, exportData } from '../../../appconfig/AppHelper';
import { dateTemplate } from '../../../appconfig/DatatableTemplateSetting';
import { inOutReportListColumns } from '../../../appconfig/DatatableSetting';
import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';
import CustomDatePicker from '../../../components/CustomDatePicker/CustomDatePicker';

export const InOutRegisterReport = () => {
    document.title = 'In-Out Register | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //collge List
    const [subTypeOptions, setSubTypeOptions] = useState<any>([]);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [errors, setErrors] = useState<any>({});
    const [selectedDegree, setSelectedDegree] = useState<any>(null);
    const [selectedMainType, setSelectedMainType] = useState<any>(null);
    const [selectedSubType, setSelectedSubType] = useState<any>(null);
    const [inOutReportList, setInOutReportList] = useState<any>([]);
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [exportLoader, setExportLoader] = useState<boolean>(false);
    const [selectedInOut, setSelecteInOut] = useState<any>(null);
    // Date Object
    let today = new Date();
    const [dates, setDates] = useState({
        start: new Date(today.setDate(today.getDate() - 30)),
        end: new Date()
    });

    // On Date Change
    const onDateChange = (start: any, end: any) => {
        setDates({ start, end });
    };
    const onInwardOutWardChange = (val: any) => {
        setSelecteInOut(val);

        if (!window.cn(val)) {
            getSubType(val);
        }
    };
    // Get sub Type
    const getSubType = async (value: any) => {
        try {
            const response = await getAllDetailsDirect(SUBTYPE + '?DataCode=' + value?.code);

            if (response) {
                const DataList: any = response?.data;
                if (DataList.length === 0) {
                    setSubTypeOptions([]);
                } else {
                    let subTypeData = [];
                    for (let i = 0; i < DataList.length; i++) {
                        const subTypeObj: any = {};
                        subTypeObj['name'] = DataList[i].Data;
                        subTypeObj['code'] = DataList[i].SrNo.toString();
                        subTypeData.push(subTypeObj);
                    }
                    setSubTypeOptions(subTypeData);
                }
            } else {
                setSubTypeOptions([]);
            }
        } catch (error: any) {
            setSubTypeOptions([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <div>
                    <label htmlFor="prefix">Inward/OutWard</label>
                    <div className="input-effect-div mt-1">
                        <Dropdown
                            style={{ minWidth: '150px' }}
                            value={selectedInOut}
                            name="inout"
                            options={inOut}
                            filter
                            optionLabel="name"
                            placeholder="Select Inward/OutWard"
                            onChange={(e) => onInwardOutWardChange(e.value)}
                            className={errors['inout'] && 'p-invalid '}
                        />
                    </div>
                    <small className="p-invalid-txt">{errors['inout']}</small>
                </div>

                <div className="ml-2">
                    <label htmlFor="prefix">Main Type</label>
                    <div className="input-effect-div mt-1">
                        <Dropdown
                            style={{ minWidth: '150px' }}
                            value={selectedMainType}
                            name="mainType"
                            options={inOutTypes}
                            filter
                            optionLabel="name"
                            placeholder="Select Type"
                            onChange={(e) => setSelectedMainType(e.value)}
                            className={errors['mainType'] && 'p-invalid'}
                        />
                    </div>
                    <small className="p-invalid-txt">{errors['mainType']}</small>
                </div>

                <div className="ml-2">
                    <label htmlFor="prefix">Sub Type</label>
                    <div className="input-effect-div mt-1">
                        <Dropdown
                            style={{ minWidth: '150px' }}
                            value={selectedSubType}
                            name="subType"
                            options={subTypeOptions}
                            filter
                            optionLabel="name"
                            placeholder="Select Type"
                            onChange={(e) => setSelectedSubType(e.value)}
                            className={errors['subType'] && 'p-invalid'}
                        />
                    </div>
                    <small className="p-invalid-txt">{errors['subType']}</small>
                </div>
                <div className="ml-2">
                    <label htmlFor="prefix">Date</label>
                    <div className="input-effect-div mt-1">
                        <CustomDatePicker startDate={dates?.start} endDate={dates?.end} onChange={onDateChange} />
                    </div>
                </div>

                <Button label="Show" onClick={() => getInOutRegisterReport()} loading={showLoading} className="ml-2 mt-4"></Button>
            </>
        );
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button icon="pi pi-file-export" label="Export" onClick={() => exportCSV()} className="p-button-success" loading={exportLoader}></Button>
                <Button icon="pi pi-download" label="Download" onClick={() => downloadAllData()} className="mx-2" loading={loading}></Button>
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAllFilter()} className="p-button-outlined "></Button>
            </>
        );
    };

    //downloadDAta
    const downloadAllData = async () => {
        try {
            setLoading(true);

            let startDate = moment(dates?.start).format('y-M-D') + ' 00:00:00';
            let endDate = moment(dates?.end).format('y-M-D') + ' 23:59:59';

            // Request Data
            const requestData = {
                from_date: startDate,
                to_date: endDate,
                type: selectedInOut?.code,
                main_type: Number(selectedMainType?.code),
                sub_type: Number(selectedSubType?.code)
            };

            const response = await downloadData(DOWNLOADINOUTREGISTER, 'InOutRegister_Report', requestData);
            if (response === true) {
                setLoading(false);
            } else if (response === false) {
                setLoading(false);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    //export CSv
    const exportCSV = async () => {
        setExportLoader(true);

        let res = await exportData('InOutRegister_Report');
        if (res === true) {
            setExportLoader(false);
        } else {
            setExportLoader(false);
        }
    };

    //Clear All Filter
    const clearAllFilter = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
    };

    // getInOutRegisterReportList
    const getInOutRegisterReport = async () => {
        try {
            // const { errors, isError } = CollegeWiseRegisterReportValidate(selectedCollege, selectedDegree);
            // setErrors(errors);
            // if (!isError) {
            setPageLoad(false);
            setShowLoading(true);

            let startDate = moment(dates?.start).format('y-M-D') + ' 00:00:00';
            let endDate = moment(dates?.end).format('y-M-D') + ' 23:59:59';

            // Request Data
            const requestData = {
                from_date: startDate,
                to_date: endDate,
                type: selectedInOut?.code,
                main_type: Number(selectedMainType?.code),
                sub_type: Number(selectedSubType?.code)
            };

            const response = await postAllData(INWARDOUTWARDREPORT, requestData);

            if (response) {
                setPageLoad(true);
                setShowLoading(false);
                setInOutReportList(response?.data);
            }
            // }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setPageLoad(true);
                setShowLoading(false);

                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    const mainTypeTemplate = (rowData: any) => {
        return <>{rowData?.TypeNo === 8 ? 'General' : rowData?.TypeNo === 118 ? 'Confidential ( Any Document from college/University)' : ''}</>;
    };

    return (
        <>
            <AppBreadcrumb currentMenu={'Reports'} pageName={'In-Out Register'} pageTitle={'In-Out Register'} goToPage={true} />

            <Toast ref={toast} />
            <div className="grid crud-demo mt-2">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={inOutReportList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Data Found"
                                    removableSort
                                >
                                    {inOutReportListColumns.map((col: any, i: any) => {
                                        if (col.field === 'EntDt') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} style={{ minWidth: '8rem' }} />;
                                        } else if (col.field === 'TypeNo') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={mainTypeTemplate} style={{ minWidth: '8rem' }} />;
                                        } else if (col.field === 'sr_no') {
                                            return <Column key={col.field} header={col.header} body={(_, { rowIndex }) => rowIndex + 1} style={{ minWidth: '4rem' }} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {inOutReportListColumns.map((col: any, i: any) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
